module.exports = __webpack_public_path__ + "static/hero-image-fa68712da71dca1c186ea8cd0bd371bf.svg";